<template>
	<div class="container">
		<div class="main_box">
			<!--块1-->
			<div class="block_1"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="400"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="bg_box">
					<img src="../../../assets/img_public/about/qyjj/block01.webp" />
				</div>
				<div class="msg_box">
					<div class="txt">Provide Affordable, Use-friendly & Precision diagnostic products for the world</div>
					<div class="tit1">Coretests</div>
					<div class="tit2">We use modern bioengineering technology and medical research results to serve the cause of global human health!</div>
				</div>
			</div>
			<!--块1-->
			<!--块2-->
			<div class="block_2"
				data-aos="fade-up"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="tit">American CorDx Union</div>
				<div class="txt">
					Core Technology Co., Ltd. is a subsidiary of the American CorDx Union group. CorDx Union (hereinafter referred to as CU) was established in 2006, serving as an international group company integrating R&D, production, marketing, and service. It has 21 subsidiaries, including Accu News, Coretests technology, Abiores, Jtests, Bonore plastics, CuPet and other brands. 
				</div>
				<div class="txt">
					CU is mainly engaged in medical devices & diagnostic reagents. Its products are sold to more than 170 countries and regions, with more than 100 million users worldwide. It is widely used in clinical testing, primary medical care, on-site law enforcement, epidemic monitoring, disaster relief, home self-test, health management and other fields.
				</div>
				<div class="txt">
					CU has four research institutes all over the world, which are located in SD, California, Daxing, Beijing, Xiong'an, Hebei and Hainan Island. It continues to improve scientific and technological innovation platforms such as molecular diagnosis, colloidal gold chromatography, fluorescence immunization, biochip, recombinant protein, mRNA vaccine, pet products, battery materials, AI quality management system, etc. Diagnosis and treatment products are mainly used for infectious diseases, tumors, cardiovascular and cerebrovascular diseases, inflammation, drug abuse and other diseases.
				</div>
				<div class="txt">
					The CU manufacturing base covers a total area of 30000 square meters, and also provides high-quality services for pharmaceutical peers.
				</div>
			</div>
			<!--块2-->
			<!--块3-->
			<div class="block_3">
				<div class="bg_box"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<img src="../../../assets/img_public/about/qyjj/block02.webp" />
				</div>
				<div class="msg_box"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="200"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="title">Our products are sold to more than 120 countries and regions,<br />with more than 1billion users worldwide.</div>
					<div class="info_el">
						<img src="../../../assets/img_public/index/icon1.webp" />
						<div class="info_info">
							<div class="info_info_box">
								<count-to :startVal="0" :endVal="170" :duration="6000" class="num"></count-to>
								<div class="add" style="right: 0;">+</div>
							</div>
							<br />
							<div class="tit">Market coverage countries and regions</div>
						</div>
					</div>
					<div class="info_el">
						<img src="../../../assets/img_public/index/icon2.webp" />
						<div class="info_info">
							<div class="info_info_box">
								<count-to :startVal="0" :endVal="100" :duration="6000" class="num"></count-to>
								<div class="add" style="left: 110px;">+</div>
								<div class="count" style="left: 110px;">Million</div>
							</div>
							<br />
							<div class="tit">Users</div>
						</div>
					</div>
					<div class="info_el">
						<img src="../../../assets/img_public/index/icon3.webp" />
						<div class="info_info">
							<div class="info_info_box">
								<count-to :startVal="0" :endVal="50" :duration="6000" class="num"></count-to>
								<div class="add" style="right: 30px;">+</div>
							</div>
							<br />
							<div class="tit">Qualifications and certifications</div>
						</div>
					</div>
					<div class="info_el">
						<img src="../../../assets/img_public/index/icon4.webp" />
						<div class="info_info">
							<div class="info_info_box">
								<count-to :startVal="0" :endVal="30" :duration="6000" class="num"></count-to>
								<div class="add" style="right: 28px;font-size: 16px;">㎡</div>
								<div class="count" style="right: -15px;">Thousand</div>
							</div>
							<br />
							<div class="tit">Area of industrial base</div>
						</div>
					</div>
				</div>
			</div>
			<!--块3-->
			<!--块4-->
			<div class="swiper_s_box"
				data-aos="fade-up"
				data-aos-duration="400"
				data-aos-delay="500"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="swiper_s_main">
					<div
						v-if="imgData.length > 0"
						class="block_banner"
					>
						<div v-if="swiperIndex != 0" class="icon_left animate__animated animate__fadeInLeft" @click="bannerLeftClick">
							<van-icon name="arrow-left" color="#ffffff" size="20px" />
						</div>
						<div v-if="swiperIndex != swiperLength" class="icon_right animate__animated animate__fadeInRight" @click="bannerRightClick">
							<van-icon name="arrow" color="#ffffff" size="20px" />
						</div>
						<van-swipe
							class=""
							:loop="false"
							:autoplay="0"
							indicator-color="white"
							ref="swipeBox"
							:stop-propagation="false"
							:show-indicators="false"
							:width="530"
							@change="onChange"
						>
							<van-swipe-item v-for="(value, index) in imgData" :key="index">
								<div class="block_banner_el">
									<div class="mask_box">
										<div class="mask_box_main">
											<div class="tit_box">
												<div class="title">{{ value.title }}</div>
												<!-- <div class="btn" @click="showBigImg(value.image)">View</div> -->
											</div>
										</div>
									</div>
									<img class="img_el" :src="value.image" @dragstart.prevent />
								</div>
							</van-swipe-item>
						</van-swipe>
					</div>
				</div>
			</div>
			<!--块4-->
		</div>
	</div>
</template>

<script>
import CountTo from 'vue-count-to';
import { ImagePreview } from 'vant';  //图片放大
export default {
	components:{
		CountTo
	},
	data() {
		return {
			imgData: [
				{ image: require('@/assets/img_public/about/qyjj/CJ_01.webp'), title: 'Factory Layout' },
				{ image: require('@/assets/img_public/about/qyjj/CJ_02.webp'), title: 'Laboratory Layout' },
				{ image: require('@/assets/img_public/about/qyjj/CJ_03.webp'), title: 'R&D Department Layout' }
			],
			swiperIndex: 0,
			swiperLength: 1,
		}
	},
	created(){
		let that = this;
	},
	mounted() {
		let that = this;
	},
	watch: {
		//
	},
	methods: {
		//点击查看大图
		showBigImg(value) {
			let that = this;
			ImagePreview({
				closeable: true,
				showIndicators: false,
				showIndex: false,
				images: [value]
			});
		},
		bannerLeftClick(value) {  //导航左侧按钮点击
			let that = this;
			that.$refs.swipeBox.prev();
		},
		bannerRightClick(value) {  //导航右侧按钮点击
			let that = this;
			that.$refs.swipeBox.next();
		},
		onChange(index) {
			let that = this;
			that.swiperIndex = index;
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	//轮播
	.swiper_s_box{
		padding: 150px 0;
		background-color: #F7F6F9;
		.swiper_s_main{
			width: 1264px;
			margin: 0 auto;
			.block_banner{
				margin: 0 auto 0px auto;
				position: relative;
				.tit{
					margin-right: 50px;
					padding-top: 30px;
					text-align: center;
					font-size: 24px;
					color: #333333;
				}
				.block_banner_el{
					position: relative;
					color: #000000;
					padding: 20px;
					margin-right: 30px;
					background-color: #ffffff;
					.mask_box{
						width: 100%;
						height: 100%;
						position: absolute;
						top: 0;
						left: 0;
						padding: 20px;
						.mask_box_main{
							display: none;
							width: 100%;
							height: 100%;
							background-color: rgba(0, 0, 0, 0.4);
							.tit_box{
								position: absolute;
								bottom: 50px;
								left: 50%;
								z-index: 1;
								transform: translate(-50%, 0);
								text-align: center;
								.btn{
									padding: 10px 50px;
									text-align: center;
									color: #ffffff;
									background: linear-gradient( 90deg, #CF0272 0%, #A20073 100%);
									border-radius: 8px 8px 8px 8px;
								}
								.title{
									padding-bottom: 12px;
									color: #ffffff;
									font-size: 20px;
								}
							}
						}
					}
					.mask_box:hover{
						.mask_box_main{
							display: block;
						}
					}
					.txt{
						padding-top: 30px;
					}
					.tit{
						padding: 10px 0 30px 0;
						font-size: 30px;
						font-weight: bold;
					}
					.img_el{
						width: 100%;
						border-radius: 10px;
					}
				}
				.icon_left{
					left: -100px;
				}
				.icon_right{
					right: -100px;
				}
				.icon_left, .icon_right{
					position: absolute;
					z-index: 1;
					top: 50%;
					margin-top: -18px;
					background: #333333;
					border-radius: 50%;
					width: 36px;
					height: 36px;
					display: flex;
					align-items: center;
					justify-content: center;
					cursor: pointer;
				}
			}
		}
	}
	//块3
	.block_3{
		position: relative;
		.msg_box{
			position: absolute;
			width: 1264px;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			.info_el{
				padding-top: 30px;
				.info_info{
					width: 360px;
					margin-left: 40px;
					padding: 0 0 0px 0px;
					display: inline-block;
					border-bottom: 1px solid #E3E1E6;
					.info_info_box{
						width: 120px;
						display: inline-block;
						position: relative;
						.count{
							position: absolute;
							bottom: 16px;
							font-size: 14px;
							line-height: 1;
							color: #A20073;
						}
						.add{
							position: absolute;
							top: 0;
							font-size: 24px;
							line-height: 1;
							color: #A20073;
						}
						.num{
							font-size: 62px;
							color: #A20073;
							line-height: 1;
						}
					}
					.tit{
						padding-top: 20px;
						margin-left: 0px;
						display: inline-block;
						position: relative;
						top: -16px;
					}
				}
				img{
					width: 48px;
					height: 48px;
				}
			}
			.title{
				padding-bottom: 20px;
				font-size: 30px;
			}
		}
		.bg_box{
			width: 100%;
			img{
				width: 100%;
				min-width: 1264px;
			}
		}
	}
	//块2
	.block_2{
		width: 1264px;
		margin: 0 auto;
		margin: 0px auto;
		padding: 50px;
		box-shadow: 0px 0px 30px 1px rgba(0,0,0,0.1);
		border-radius: 12px 12px 12px 12px;
		.txt{
			padding-bottom: 10px;
			font-size: 18px;
			line-height: 36px;
		}
		.tit{
			padding-bottom: 15px;
			font-size: 36px;
			color: #A50073;
		}
	}
	//块1
	.block_1{
		position: relative;
		.msg_box{
			position: absolute;
			width: 1264px;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			.tit2{
				font-size: 24px;
				color: #A50073;
			}
			.tit1{
				padding: 26px 0 20px 0;
				font-size: 46px;
			}
			.txt{
				font-size: 18px;
			}
		}
		.bg_box{
			width: 100%;
			img{
				width: 100%;
				min-width: 1264px;
			}
		}
	}
}
</style>